import { ParserFunctionInterface } from '../../';

type CookiePanelType = {
  level: { title: string; value: string };
  time: { title: string; value: string };
  id: { title: string; value: string };
};

const QUERY_SELECTOR = '[data-module="cookie-consent-status"]';

function buildRow(title: string, value: string): HTMLDivElement {
  const row = document.createElement('div');

  const titleSpan = document.createElement('span');
  titleSpan.textContent = `${title}: `;

  const valueSpan = document.createElement('span');
  valueSpan.textContent = value;

  row.append(titleSpan, valueSpan);
  return row;
}

let CookiePanel: ParserFunctionInterface;
CookiePanel = (el: any) => {
  const arrCookieConsent = el.querySelectorAll(QUERY_SELECTOR);

  function init() {
    if (arrCookieConsent.length > 0) {
      processCookieDetails(arrCookieConsent);
    }
  }

  function processCookieDetails(arrCookieConsent: any[]) {
    const apiUrl = '/api/ccstatus';
    fetch(apiUrl, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((json: CookiePanelType) => {
        const node = arrCookieConsent[0];

        // Build the DOM with createElement/textContent instead of innerHTML string interpolation,
        // so the API response can never be parsed as markup/scripts.
        node.replaceChildren(
          buildRow(json?.level?.title, json?.level?.value),
          buildRow(json?.id?.title, json?.id?.value),
          buildRow(json?.time?.title, json?.time?.value)
        );
      })
      .catch((error) => {
        console.warn('cookie status api failed: ', error);
      });
  }
  return {
    init,
  };
};

export default CookiePanel;
